import { render } from "./Gameboard_SideButtons.vue?vue&type=template&id=07176e3a"
import script from "./Gameboard_SideButtons.vue?vue&type=script&lang=js"
export * from "./Gameboard_SideButtons.vue?vue&type=script&lang=js"

import "./Gameboard_SideButtons.vue?vue&type=style&index=0&id=07176e3a&lang=css"
script.render = render

export default script